import _this from '@/main.js'

export const doVerifyQuota = async (questionsList, quotatypeList) => {
    // 创建所有 Promise
    const promises = questionsList.map((question, index) => {
        return new Promise((resolve, reject) => {
            quotaCollection(question, quotatypeList, resolve, reject, questionsList);
        }).then(result => ({
            index,
            result,
            success: true
        })).catch(error => ({
            index,
            result: false,
            success: false,
            error
        }));
    });
    
    // 等待所有 Promise 完成
    const allResults = await Promise.all(promises);
    
    console.log('all results :>> ', allResults);
    
    let result;
    // 检查是否有任何请求返回 true
    if (allResults.some(item => item.result === true)) {
        result = 14;
    }
    
    console.log('final result :>> ', result);
    return result;
}

const quotaCollection = (data, quotatypeList, resolve, reject, questionsList) => {
    if (quotatypeList.length == 0) {
        resolve(false);
        return;
    }
    
    let hasQuota = false;
    for (let i in quotatypeList) {
        if (quotatypeList[i].rlueConditionOne == data.qid) {
            hasQuota = true;
            if (data.userAnswer) {
                quotaAnswer(quotatypeList[i], data.userAnswer, 1, resolve, reject, quotatypeList, questionsList);
            } else if (data.userAnswerArr) {
                quotaAnswerArr(quotatypeList[i], data.userAnswerArr, 1, resolve, reject, quotatypeList, questionsList);
            }
        } else if (quotatypeList[i].rlueConditionTwo == data.qid) {
            hasQuota = true;
            if (data.userAnswer) {
                quotaAnswer(quotatypeList[i], data.userAnswer, 2, resolve, reject, quotatypeList, questionsList);
            } else if (data.userAnswerArr) {
                quotaAnswerArr(quotatypeList[i], data.userAnswerArr, 2, resolve, reject, quotatypeList, questionsList);
            }
        }
    }
    
    // 如果没有匹配的配额规则，直接resolve false
    if (!hasQuota) {
        resolve(false);
    }
}

const quotaAnswer = (info, answer, number, resolve, reject, quotatypeList, questionsList) => {
    let matched = false;
    for (let i in info.questionnaireNewQuotaDetailsList) {
        let data = info.questionnaireNewQuotaDetailsList[i];
        if (data.quotaNumber > 0) {
            if (number == 1 && answer == data.optionOneCondition) {
                if (info.ruleConditionTwoType == 1) {
                    getQuotaInfo(data.id, resolve, reject);
                    matched = true;
                    break;
                } else {
                    validateQuota(info, data, 1, resolve, reject, quotatypeList, questionsList);
                    matched = true;
                    break;
                }
            } else if (number == 2 && answer == data.optionTwoCondition) {
                if (info.ruleConditionOneType == 1) {
                    getQuotaInfo(data.id, resolve, reject);
                    matched = true;
                    break;
                } else {
                    validateQuota(info, data, 2, resolve, reject, quotatypeList, questionsList);
                    matched = true;
                    break;
                }
            }
        }
    }
    
    // 如果没有匹配的配额详情，resolve false
    if (!matched) {
        resolve(false);
    }
}

const quotaAnswerArr = (info, answerArr, number, resolve, reject, quotatypeList, questionsList) => {
    let matched = false;
    for (let i in info.questionnaireNewQuotaDetailsList) {
        let data = info.questionnaireNewQuotaDetailsList[i];
        if (data.quotaNumber > 0) {
            if (number == 1 && answerArr.indexOf(data.optionOneCondition) !== -1) {
                if (info.ruleConditionTwoType == 1) {
                    getQuotaInfo(data.id, resolve, reject);
                    matched = true;
                    break;
                } else {
                    validateQuota(info, data, 1, resolve, reject, quotatypeList, questionsList);
                    matched = true;
                    break;
                }
            } else if (number == 2 && answerArr.indexOf(data.optionTwoCondition) !== -1) {
                if (info.ruleConditionOneType == 1) {
                    getQuotaInfo(data.id, resolve, reject);
                    matched = true;
                    break;
                } else {
                    validateQuota(info, data, 2, resolve, reject, quotatypeList, questionsList);
                    matched = true;
                    break;
                }
            }
        }
    }
    
    // 如果没有匹配的配额详情，resolve false
    if (!matched) {
        resolve(false);
    }
}

// 关键修改：将 getQuotaInfo 改为返回 Promise
const getQuotaInfo = (id, resolve, reject) => {
    return new Promise((innerResolve, innerReject) => {
        let params = {
            that: _this,
            url: `${_this.$config.service.verifyQuota}`,
            method: 'POST',
            data: {
                id: id
            },
            cb(res) {
                console.log('getQuotaInfo response:', res);
                if (res.code == 0) {
                    const result = res.resultBody == 1;
                    console.log('getQuotaInfo result:', result, 'res.resultBody:', res.resultBody);
                    innerResolve(result);
                } else {
                    console.warn('配额验证返回非0 code:', res.code);
                    innerResolve(false);
                }
            },
            errCb(err) {
                console.error('配额验证请求失败:', err);
                innerResolve(false);
            }
        };
        params.isnologin = true;
        
        console.log('开始调用配额验证接口，id:', id);
        _this.$util.request(params);
    });
}

// 重构 validateQuota，使其等待 getQuotaInfo 完成
const validateQuota = async (obj, objItem, number, resolve, reject, quotatypeList, questionsList) => {
    let result = false;
    
    try {
        for (let el in quotatypeList) {
            if (quotatypeList[el].id == obj.id) {
                for (let quotaIndex in quotatypeList[el].questionnaireNewQuotaDetailsList) {
                    let val = quotatypeList[el].questionnaireNewQuotaDetailsList[quotaIndex];
                    if (val.quotaNumber > 0) {
                        if (objItem.optionTwoCondition) {
                            if (objItem.optionTwoCondition == val.optionTwoCondition) {
                                if (number == 1) {
                                    if (obj.rlueConditionTwo) {
                                        for (let j in questionsList) {
                                            if (questionsList[j].userAnswer && questionsList[j].userAnswer == val.optionTwoCondition) {
                                                console.log('validateQuota calling getQuotaInfo for val.id:', val.id);
                                                // 等待 getQuotaInfo 完成
                                                result = await getQuotaInfo(val.id, resolve, reject);
                                                console.log('validateQuota getQuotaInfo 完成，结果:', result);
                                                resolve(result);
                                                return;
                                            } else if (
                                                questionsList[j].userAnswerArr &&
                                                questionsList[j].userAnswerArr.indexOf(val.optionTwoCondition) !== -1
                                            ) {
                                                console.log('validateQuota calling getQuotaInfo for val.id:', val.id);
                                                // 等待 getQuotaInfo 完成
                                                result = await getQuotaInfo(val.id, resolve, reject);
                                                console.log('validateQuota getQuotaInfo 完成，结果:', result);
                                                resolve(result);
                                                return;
                                            }
                                        }
                                    }
                                } else if (number == 2) {
                                    if (obj.rlueConditionOne) {
                                        for (let j in questionsList) {
                                            if (questionsList[j].userAnswer && questionsList[j].userAnswer == val.optionOneCondition) {
                                                console.log('validateQuota calling getQuotaInfo for val.id:', val.id);
                                                // 等待 getQuotaInfo 完成
                                                result = await getQuotaInfo(val.id, resolve, reject);
                                                console.log('validateQuota getQuotaInfo 完成，结果:', result);
                                                resolve(result);
                                                return;
                                            } else if (
                                                questionsList[j].userAnswerArr &&
                                                questionsList[j].userAnswerArr.indexOf(val.optionOneCondition) !== -1
                                            ) {
                                                console.log('validateQuota calling getQuotaInfo for val.id:', val.id);
                                                // 等待 getQuotaInfo 完成
                                                result = await getQuotaInfo(val.id, resolve, reject);
                                                console.log('validateQuota getQuotaInfo 完成，结果:', result);
                                                resolve(result);
                                                return;
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            console.log('validateQuota calling getQuotaInfo for objItem.id:', objItem.id);
                            // 等待 getQuotaInfo 完成
                            result = await getQuotaInfo(objItem.id, resolve, reject);
                            console.log('validateQuota getQuotaInfo 完成，结果:', result);
                            resolve(result);
                            return;
                        }
                    }
                    if (result) {
                        break;
                    }
                }
                if (result) {
                    break;
                }
            }
            if (result) {
                break;
            }
        }
    } catch (error) {
        console.error('validateQuota 执行错误:', error);
        resolve(false);
        return;
    }
    
    // 如果循环结束都没有找到匹配，则手动resolve false
    console.log('validateQuota no match, resolving false');
    resolve(false);
}